<template>
  <div id="container-color-scale" class="d-flex flex-column position-relative">
    <template v-for="(item, index) in $props.data.colorScale" :key="index">
      <div class="d-flex color-scale align-items-center justify-content-between p-3"
          :class="{'select': item.selected}"
          @click="toggleColorSelected(index)">
        <span class="d-flex color-name text-violet">
          {{ displayName(item.name) }}
        </span>
        <div class="d-flex counts" style="width: max-content;">
          <span class="d-flex text-danger mx-2">
            {{ getCountPastWorks(item.toWorkBeforeDayGroupedByColor.works) }}
          </span>
          <span class="d-flex text-warning mx-2">
            {{ getCountUrgentWorks(item.toWorkInTheDayGroupedByColor.works) }}
          </span>
          <span class="d-flex text-gray mx-2">
            {{ getCountFutureWorks(item.toWorkGroupedByColor.works) }}
          </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import {ref, watch} from "vue";
import _head from "lodash/head";
import { useAssets } from "@/composables/useAssets";
export default {
  name: "ColorScale",
  props: [
    'data',
  ],
  emits: [
    'colorSelected',
  ],
  setup(props, {emit}) {
    const { getLabelsNameByAsset } = useAssets();
    const selected = ref(false);
    
    const applicationNames = ['Arcata', 'Moncone', 'Gengiva', 'Gig', 'Barretta', 'Barra', 'Base vallo', 'Perno Custom'];
    
    const displayName = (name) => {
      if (applicationNames.includes(name)) {
        return name;
      }
      return getLabelsNameByAsset(name);
    };
    const assetsCount = (array) => {
      let count = 0;
      Object.values(array).forEach((el) => {
        el.forEach((el) => {
          count += el.assets.length;
        })
      });

      return count;
    }

    const getCountPastWorks = (beforeDay) => {
      return assetsCount(beforeDay);
    }

    const getCountUrgentWorks = (inTheDay) => {
      return assetsCount(inTheDay);
    }

    const getCountFutureWorks = (future) => {
      return assetsCount(future);
    }

    watch(() => props.data.colorScale, () => {
      if (!props.data.colorScale.some((el) => el.selected === true)) {
        emit('colorSelected', _head(props.data.colorScale));
      } else {
        let index = props.data.colorScale.findIndex((el) => el.selected === true);
        emit('colorSelected', props.data.colorScale[index]);
      }
    });

    const toggleColorSelected = (indexSelected) => {
      props.data.colorScale.forEach((el, index) => {
        if (index === indexSelected) {
          if (!el.selected) {
            el.selected = true;
            selected.value = true;
            emit('colorSelected', el);
          }
        } else {
          el.selected = false;
          selected.value = false;
        }
      });
    }

    return {
      toggleColorSelected,
      getCountPastWorks,
      getCountUrgentWorks,
      getCountFutureWorks,
      getLabelsNameByAsset,
      displayName,
    }
  }
}
</script>

<style scoped>
  #container-color-scale {
    background-color: #F2F2F2;
    border-top-left-radius: 1rem !important;
    border-bottom-left-radius: 1rem !important;
    width: 18em;
    overflow: auto;
  }
  .color-name {
    font-size: 1.8em;
  }
  .counts {
    font-size: 1.3em;
  }
  .color-scale:hover {
    cursor: pointer;
  }
  .select {
    background-color: white;
    box-shadow: 0 4px 2px -2px #9D9D9D;
    border-top-left-radius: 1rem !important;
    border-bottom-left-radius: 1rem !important;
  }
  .text-danger {
    color: #dc3545 !important;
  }
  .text-warning {
    color: #ffc107 !important;
  }
  .text-gray {
    color: #6c757d !important;
  }
</style>
